import React, {memo} from 'react';

import {isNetlify, isProduction} from '../../../libs/shared/helpers/src/environment/envHelpers';
import googleAnalyticsFrame from '../../assets/frames/googleAnalytics.html';
import {Iframe} from '../common/iframe';

/*
 * Component.
 */

export const GoogleAnalyticsFrame = memo(() => {
  // Only render the script in production.
  if (!isProduction() && !isNetlify()) {
    return null;
  }

  // Render the Google Analytics script from the public asset inside an iframe.
  // This allows us to exclude users from paid marketing campaigns.
  return (
    <Iframe
      title="Google Analytics"
      endpoint={googleAnalyticsFrame}
      isVisible={false}
      sandboxPermissions="allow-scripts"
    />
  );
});
